var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _polygon, _rect20, _rect21, _polygon2, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _rect32, _polygon9, _polygon10, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _polygon11, _polygon12, _polygon13, _polygon14, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect40, _path12, _path13, _rect41, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse2, _ellipse3, _rect42, _rect43, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _ellipse4, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _polygon15, _path108, _polygon16, _path109, _path110, _path111, _path112;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 600",
    style: {
      enableBackground: "new 0 0 700 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#79E2F2;}\n\t.st1{fill:#4C9AFF;}\n\t.st2{fill:#FFE380;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{opacity:0.5;fill:url(#SVGID_2_);enable-background:new    ;}\n\t.st5{fill:#00C7E5;}\n\t.st6{fill:url(#SVGID_3_);}\n\t.st7{opacity:0.5;}\n\t.st8{fill:url(#SVGID_4_);}\n\t.st9{fill:#EBECF0;}\n\t.st10{fill:url(#SVGID_5_);}\n\t.st11{fill:url(#SVGID_6_);}\n\t.st12{fill:#0065FF;}\n\t.st13{fill:#FAFBFC;}\n\t.st14{fill:url(#SVGID_7_);}\n\t.st15{fill:#B2D4FF;}\n\t.st16{fill:#FFFFFF;}\n\t.st17{fill:#DFE1E5;}\n\t.st18{fill:#253858;}\n\t.st19{fill:#FFAB00;}\n\t.st20{fill:#CF9E76;}\n\t.st21{fill:url(#SVGID_8_);}\n\t.st22{fill:#FFD740;}\n\t.st23{fill:#FF991F;}\n\t.st24{fill:url(#SVGID_9_);}\n\t.st25{fill:#8C715D;}\n\t.st26{fill:#162B4C;}\n\t.st27{fill:#8893A5;}\n\t.st28{fill:none;}\n\t.st29{fill:#27375C;}\n\t.st30{fill:#008DA6;}\n\t.st31{fill:#00B8D9;}\n\t.st32{fill:url(#SVGID_10_);}\n\t.st33{fill:url(#SVGID_11_);}\n\t.st34{fill:#E6FCFF;}\n\t.st35{fill:#1DB9D4;}\n\t.st36{fill:url(#SVGID_12_);}\n\t.st37{fill:url(#SVGID_13_);}\n\t.st38{fill:url(#SVGID_14_);}\n\t.st39{fill:url(#SVGID_15_);}\n\t.st40{fill:url(#SVGID_16_);}\n\t.st41{fill:url(#SVGID_17_);}\n\t.st42{fill:url(#SVGID_18_);}\n\t.st43{fill:url(#SVGID_19_);}\n\t.st44{fill:url(#SVGID_20_);}\n\t.st45{fill:url(#SVGID_21_);}\n\t.st46{fill:url(#SVGID_22_);}\n\t.st47{fill:url(#SVGID_23_);}\n\t.st48{fill:url(#SVGID_24_);}\n\t.st49{fill:url(#SVGID_25_);}\n\t.st50{fill:url(#SVGID_26_);}\n\t.st51{fill:url(#SVGID_27_);}\n\t.st52{fill:url(#SVGID_28_);}\n\t.st53{fill:url(#SVGID_29_);}\n\t.st54{fill:url(#SVGID_30_);}\n\t.st55{fill:url(#SVGID_31_);}\n\t.st56{fill:url(#SVGID_32_);}\n\t.st57{fill:url(#SVGID_33_);}\n\t.st58{fill:url(#SVGID_34_);}\n\t.st59{fill:url(#SVGID_35_);}\n\t.st60{fill:url(#SVGID_36_);}\n\t.st61{fill:url(#SVGID_37_);}\n\t.st62{fill:url(#SVGID_38_);}\n\t.st63{fill:url(#SVGID_39_);}\n\t.st64{fill:url(#SVGID_40_);}\n\t.st65{fill:url(#SVGID_41_);}\n\t.st66{fill:url(#SVGID_42_);}\n\t.st67{fill:url(#SVGID_43_);}\n\t.st68{fill:url(#SVGID_44_);}\n\t.st69{fill:url(#SVGID_45_);}\n\t.st70{fill:url(#SVGID_46_);}\n\t.st71{fill:url(#SVGID_47_);}\n\t.st72{fill:url(#SVGID_48_);}\n\t.st73{fill:url(#SVGID_49_);}\n\t.st74{fill:url(#SVGID_50_);}\n\t.st75{fill:url(#SVGID_51_);}\n\t.st76{fill:url(#SVGID_52_);}\n\t.st77{fill:url(#SVGID_53_);}\n\t.st78{fill:url(#SVGID_54_);}\n\t.st79{fill:url(#SVGID_55_);}\n\t.st80{fill:url(#SVGID_56_);}\n\t.st81{fill:url(#SVGID_57_);}\n\t.st82{fill:url(#SVGID_58_);}\n\t.st83{fill:url(#SVGID_59_);}\n\t.st84{fill:url(#SVGID_60_);}\n\t.st85{fill:url(#SVGID_61_);}\n\t.st86{fill:url(#SVGID_62_);}\n\t.st87{fill:url(#SVGID_63_);}\n\t.st88{fill:url(#SVGID_64_);}\n\t.st89{fill:url(#SVGID_65_);}\n\t.st90{fill:url(#SVGID_66_);}\n\t.st91{fill:url(#SVGID_67_);}\n\t.st92{fill:url(#SVGID_68_);}\n\t.st93{fill:url(#SVGID_69_);}\n\t.st94{fill:url(#SVGID_70_);}\n\t.st95{fill:url(#SVGID_71_);}\n\t.st96{fill:url(#SVGID_72_);}\n\t.st97{fill:url(#SVGID_73_);}\n\t.st98{fill:url(#SVGID_74_);}\n\t.st99{fill:url(#SVGID_75_);}\n\t.st100{fill:#D4B696;}\n\t.st101{fill:#0057D8;}\n\t.st102{fill:url(#SVGID_76_);}\n\t.st103{fill:#172B4D;}\n\t.st104{fill:url(#SVGID_77_);}\n\t.st105{fill:#243759;}\n\t.st106{fill:url(#SVGID_78_);}\n\t.st107{fill:#505F79;}\n\t.st108{fill:#A27F68;}\n\t.st109{fill:#B5917C;}\n\t.st110{fill:url(#SVGID_79_);}\n\t.st111{fill:url(#SVGID_80_);}\n\t.st112{fill:url(#SVGID_81_);}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cobra id pages_default_right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 265.7,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -42.0517 87.2238)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 246.3,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -38.4378 86.8837)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 226.9,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -34.8238 86.5454)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 207.5,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -31.21 86.2054)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 188.1,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -27.5962 85.8653)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 168.7,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -23.9822 85.527)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 149.3,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -20.3702 85.1875)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 129.9,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -16.7563 84.8474)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 110.5,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -13.1423 84.5091)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 91.1,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -9.5285 84.1691)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 71.7,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -5.9147 83.829)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 52.2,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -2.3007 83.4907)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 32.8,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 1.3113 83.1512)",
    className: "st0",
    width: 24.5,
    height: 3.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 466.9,
    y: 240.6,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -35.0481 111.4887)",
    className: "st0",
    width: 218.3,
    height: 3.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 467.2,
    y: 224.5,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -32.3617 107.9444)",
    className: "st0",
    width: 182.6,
    height: 3.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 467.3,
    y: 206.3,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -29.0753 106.4619)",
    className: "st0",
    width: 169.9,
    height: 3.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 552.3,
    y: 181.6,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -23.9834 111.2563)",
    className: "st1",
    width: 56.2,
    height: 3.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 468.2,
    y: 196.3,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -28.0914 97.0149)",
    className: "st1",
    width: 68.5,
    height: 3.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 467.4,
    y: 168.3,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -22.0801 104.9848)",
    className: "st0",
    width: 161,
    height: 3.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "541.7,150.1 542.3,153.5 700,123.6 700,120.1  "
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 468.3,
    y: 158.2,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -21.0663 95.6294)",
    className: "st2",
    width: 60.6,
    height: 3.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 467.4,
    y: 129.5,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -14.8544 104.2978)",
    className: "st0",
    width: 160.9,
    height: 3.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "468.5,125.1 469.1,128.6 700,84.8 700,81.2  "
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 558.1,
    y: 83.9,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -5.753 110.1161)",
    className: "st1",
    width: 50.7,
    height: 3.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 468.1,
    y: 98.2,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -9.7128 96.3955)",
    className: "st0",
    width: 80.5,
    height: 3.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 466.8,
    y: 65,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -2.2681 109.3327)",
    className: "st0",
    width: 228.3,
    height: 3.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 560.6,
    y: 45.3,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 1.4097 109.2205)",
    className: "st0",
    width: 43.2,
    height: 3.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 58.1,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -2.1421 96.9137)",
    className: "st0",
    width: 93.8,
    height: 3.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 541.6,
    y: 23.3,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 5.7581 111.4204)",
    className: "st2",
    width: 108.9,
    height: 3.5
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 468.3,
    y: 41.5,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 0.6948 93.8821)",
    className: "st1",
    width: 63.9,
    height: 3.5
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 468.1,
    y: 20.1,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 4.8696 95.4813)",
    className: "st0",
    width: 85.4,
    height: 3.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -5380.145,
    y1: -50.7214,
    x2: -5418.2256,
    y2: 165.2214,
    gradientTransform: "matrix(-1 0 0 -1 -5068.1401 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#00C7E5",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C7E5",
      stopOpacity: 0.4
    }
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4,
    y: 485.5,
    className: "st3",
    width: 613.3,
    height: 114.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -5614.8101,
    y1: -4.93,
    x2: -5614.8101,
    y2: 301.73,
    gradientTransform: "matrix(-1 0 0 -1 -5068.1401 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#0065FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#0065FF",
      stopOpacity: 0.5
    }
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 393.3,
    y: 298.3,
    className: "st4",
    width: 306.7,
    height: 306.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "24.6,485.5 331.2,427.4 637.9,485.5 331.2,543.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -5768.1401,
    y1: 301.835,
    x2: -5461.4702,
    y2: 301.835,
    gradientTransform: "matrix(-1 0 0 -1 -5068.1401 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#2684FF"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "393.3,298.2 700,240.1 700,356.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -5596.0903,
    y1: 278.1003,
    x2: -5571.4399,
    y2: 138.268,
    gradientTransform: "matrix(-1 0 0 -1 -5068.1401 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#1379FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#379EF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#54BCF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#69D1F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#75DEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#79E2F2"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "393.3,298.2 700,356.3 637.9,485.5 331.2,427.4  "
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "71.3,493.9 284.3,534.3 435.1,505.7 222.1,465.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.06,
    y1: 113.65,
    x2: 365.06,
    y2: 470.61,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#0065FF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2D4FF",
      stopOpacity: 0
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "258.8,129.4 258.8,446 471.4,486.4 471.4,170  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.38,
    y1: 103.75,
    x2: 346.38,
    y2: 460.71,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#0065FF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2D4FF",
      stopOpacity: 0
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "240.1,139.3 240.1,455.9 452.7,496.2 452.7,179.9  "
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 284.4,
    y: 378.4,
    transform: "matrix(0.1867 -0.9824 0.9824 0.1867 -179.7591 622.0447)",
    className: "st12",
    width: 2.8,
    height: 82.4
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "435.1,247.5 435.1,505.7 222.5,465.3 222.5,148.8 384.4,179.5 435,247.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.1301,
    y1: 904.6069,
    x2: 470.0101,
    y2: 965.4869,
    gradientTransform: "matrix(0.99 0.19 0 -1 -36.98 1074.73)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAFBFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#EFF1F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#D1D6DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C1C7D0"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "384.7,269 435,247.3 384.7,180  "
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 349.8,
    y: 381.9,
    transform: "matrix(0.1867 -0.9824 0.9824 0.1867 -152.5178 708.9667)",
    className: "st15",
    width: 4.3,
    height: 129.3
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 411.4,
    transform: "matrix(0.1903 -0.9817 0.9817 0.1903 -208.2829 612.7254)",
    className: "st2",
    width: 7.5,
    height: 42.5
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 298.4,
    y: 396.3,
    transform: "matrix(0.1867 -0.9824 0.9824 0.1867 -198.9269 662.3083)",
    className: "st15",
    width: 4.3,
    height: 109.9
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 327.3,
    y: 342.2,
    transform: "matrix(0.1867 -0.9824 0.9824 0.1867 -151.4575 673.4219)",
    className: "st2",
    width: 7.5,
    height: 171.9
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 319.6,
    y: 145.6,
    transform: "matrix(0.1867 -0.9824 0.9824 0.1867 43.4908 496.8028)",
    className: "st15",
    width: 4.3,
    height: 153.1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 298.4,
    y: 177.6,
    transform: "matrix(0.1867 -0.9824 0.9824 0.1867 15.9874 484.3987)",
    className: "st15",
    width: 4.3,
    height: 109.9
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 319.6,
    y: 131.1,
    transform: "matrix(0.1867 -0.9824 0.9824 0.1867 57.6797 485.0465)",
    className: "st15",
    width: 4.3,
    height: 153.1
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "435.1,247.5 384.4,237.9 384.4,179.5  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "415.4,421 245.3,388.7 245.3,245.2 415.4,277.5  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "346.4,308.6 396.4,383.2 296.4,364.2  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "296.1,323.7 327.9,370.2 264.4,358.2  "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.919 -0.3943 0.3943 0.919 -93.9173 140.9847)",
    className: "st19",
    cx: 296.1,
    cy: 299.1,
    rx: 7.4,
    ry: 9.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M378.9,403.5c-0.7,0.5-1.2,1-1.7,1.7c-0.4,0.6-0.7,1.2-0.9,1.9c-0.2,0.6-0.2,1.2,0,1.8 c0.4,0.9,1.3,1.4,2.2,1.3c0.5,0,1-0.3,1.3-0.7c0.6-0.8,0.2-1.6,1-2.4c1.1-1.5,2.6-0.6,2.7-1.4s-0.7-1.5-1.8-2.1 C381.6,403.5,379.6,402.9,378.9,403.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.3448,
    y1: 248.8911,
    x2: 290.22,
    y2: 248.8911,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FF991F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAB00"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M282.2,430.8l1,1.4l7-4.7l-1.3-1.9c-2.2-3.3-3.2-7.3-2.8-11.2l0-0.5c0.4-4-0.6-7.9-2.8-11.2l-85.3-126.9 c-4-5.9-12-7.5-18-3.5l0,0c-5.9,4-7.5,12.1-3.5,18l85,126.4c2.4,3.6,6.1,6.1,10.4,7.1l0,0C276.1,424.7,279.8,427.2,282.2,430.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M229.5,369c0.1-7,0.9-16.3,1.4-23.5c0.6-7.4,1-13.8,1.3-19.1l-6.6-9.9c0.1,8.1-0.9,20.1-1.5,28.4 c-0.4,5.5-0.8,10.2-1,14.4L229.5,369z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M201,280.1c-1.4,37.7,1.9,46.4,7.7,47.6c5.2,1,8.8-5.1,12.6-11.6c0.5-0.9,1.2-2,1.8-3l-4.2-6.2 c-1.2,1.7-2.4,3.7-3.6,5.8c-1.4,2.4-3.8,6.5-5.3,7.9c-1-1.9-2.8-8.4-2.4-30.5L201,280.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M244.2,344.3c-5.9,15.1-9.9,23.5-12.4,28.1l4.2,6.3c3.1-4.8,7.1-13.2,12.8-27.5L244.2,344.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M290.1,437l2.1-3.1c0.3-0.4,0.3-1,0-1.4l-3-4.4l-5,3.4l3.8,5.5c0.4,0.6,1.2,0.8,1.8,0.4 C289.9,437.3,290,437.2,290.1,437z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.7516,
    y1: 675.8587,
    x2: 470.0215,
    y2: 704.1287,
    gradientTransform: "matrix(0.94 0.37 0.2 -0.98 -171.54 918.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF991F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAB00"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M409.1,399.8l-20.3-8.1c-2-0.9-4.3,0-5.2,1.9c-0.1,0.3-0.2,0.6-0.3,1l-4.4,21.1c-0.5,2.7,1,5.4,3.5,6.5l5,2 l2.6,7c0.3,1,1.2,1.6,2.2,1.3c0.2,0,0.4-0.1,0.5-0.2l4.9-4l5,2c2,0.9,4.3,0,5.2-1.9c0.1-0.3,0.2-0.6,0.3-1l4.4-21.1 C413,403.6,411.6,400.9,409.1,399.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M218.3,345.6c0.1,0.7,0,1.4-0.3,2c-0.4,1-1.8,4.3-2.9,4.1c-0.5-0.1-0.7-1-0.8-1.5c-0.1-0.9,1-1.4,1.1-2.3 c0-0.2,0-0.4,0.1-0.6c0.1-0.6,0.1-0.9,0.3-0.9s0.5,0.5,0.9,0.5c0.7,0,1-2.1,1.4-2.1C218.2,344.9,218.2,345.4,218.3,345.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M212.1,352.1c0.9,0.8,3,0.4,4.1-0.9c0.6-0.8,0.9-1.9,0.7-2.9c-0.1-1.1-0.6-1.2-0.9-2.3 c-0.7-2.3,0.4-4.3-0.2-4.6c-0.1-0.1-0.4,0-0.9,0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.4,0-0.6,0.6-0.7,0.9c-0.7,1.8-1.2,3.5-1.6,5.4 C211.8,350.5,211.6,351.7,212.1,352.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M212.2,344.7c-0.2,0.8-0.3,1.6-0.1,2.3c0,2.8-0.4,4.6-0.2,4.6s0.3-0.6,0.4-0.9c0.9-2.6,2.2-8,1.4-8.2 C213.4,342.5,212.6,343.6,212.2,344.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "_Clipping_Path_12",
    className: "st26",
    d: "M203.2,499.5l-11.6-2.5l1.6-7.4l3.6,1.8c0,1.3,0.5,2.5,1.4,3.5 c1.5,1.4,3.5,1,4.6,2.6C203.1,498.1,203.3,498.8,203.2,499.5z"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 491.7,
    transform: "matrix(0.2094 -0.9778 0.9778 0.2094 -330.8125 586.4894)",
    className: "st27",
    width: 0.8,
    height: 12.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M203.2,499.5l-11.6-2.5l1.6-7.4l3.6,1.8c0,1.3,0.5,2.5,1.4,3.5c1.5,1.4,3.5,1,4.6,2.6 C203.1,498.1,203.3,498.8,203.2,499.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "_Clipping_Path_13",
    className: "st26",
    d: "M253.3,498.6h-13.2v-8.4l4.3,0.2c0.4,2.8,1.5,3.9,2.3,4.4c1.9,1.2,4,0.2,5.6,1.7 C252.8,497.1,253.1,497.8,253.3,498.6z"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 239.8,
    y: 497.7,
    className: "st27",
    width: 13.7,
    height: 0.9
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M253.3,498.6h-13.2v-8.4l4.3,0.2c0.4,2.8,1.5,3.9,2.3,4.4c1.9,1.2,4,0.2,5.6,1.7 C252.8,497.1,253.1,497.8,253.3,498.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227.7,397.1c-1.2-0.9-2.1-2.2-2.6-3.6c-1.3-4,0.8-8.3,4.9-9.7c2.3-0.8,4.7-0.4,6.7,0.9 c1.3-0.5,2.9,0.1,3.4,1.4c0.4,1,0.2,2.1-0.5,2.8c0,0.3,0,0.5-0.1,0.8c-0.7,2.7-2.3,5-4.6,6.5L227.7,397.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M232.5,404.3c-2.5,0.9-5.3,0.4-7.4-1.3c1.7-2,2.6-4.5,2.8-7.1l6.2,1.1L232.5,404.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M239.6,389c0,0.9,0,1.8,0.1,2.8c0.1,0.6,0.2,1.1,0.2,1.2c0.2,1.1,0.5,2.1,0.9,3.1l-1.5,0.2l-1.4,4.8 c-2.1,0.4-4.2,0.5-6.3,0.1c-1.8-0.3-3.5-0.7-4.3-2c-0.2-0.5-0.4-1-0.5-1.5c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.4-0.3-0.9-0.6-1.6 c0.6,0.4,1.3,0.6,1.9,0.6c0.7,0.1,1.4,0,1.9-0.4c0.8-0.7,0.2-2,0.9-2.3c0.3-0.1,0.7-0.1,0.9,0.1c0.8,0.6,0.4,2.5,0.4,2.5h1.4 c0.1-0.9,0.4-1.7,0.9-2.4c0.8-1.1,1.4-1.1,2-2.2s0.2-1.7,0.7-2.1S238,388.4,239.6,389z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M257,376.7c0,0.6,0.1,1.3,0.4,1.9c0.5,0.9,2,3.9,3,3.6c0.5-0.1,0.6-1,0.6-1.4c0-0.8-1-1.2-1.2-2.1 c0-0.2,0-0.3-0.1-0.5c-0.1-0.5-0.2-0.8-0.3-0.8s-0.4,0.6-0.8,0.6c-0.6,0-1-1.9-1.4-1.8C257.1,376.1,257,376.6,257,376.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M213.2,422.9c-1.2,2.1-2.2,4.4-3.2,6.7c-3.8,8.8-6.4,18.1-7.6,27.6c-1.4,3.2-2.7,6.5-4,10.1 c-2.7,7.8-4.8,15.8-6.3,24l6.2,1.4l12-32.4l2.6-5.7c8.1-17.5,8.8-20.5,7.9-23.7C220.3,429.1,218.7,425.9,213.2,422.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M263.8,382.5c-0.8,0.9-3,0.6-4.1-0.6c-0.7-0.8-1-1.8-0.9-2.8c0.1-1.1,0.5-1.2,0.8-2.3 c0.6-2.3-0.7-4.3-0.1-4.6c0.1-0.1,0.4,0,0.9,0.4c0.1-0.1,0.2-0.2,0.4-0.2c0.4,0,0.6,0.6,0.7,0.9c0.8,1.7,1.5,3.4,2,5.2 C263.9,380.8,264.2,382,263.8,382.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M229,426.5c4.3,10.2,7.8,20.7,10.8,31.4c3,11.1,5.3,22.3,6.9,33.7h-7.2c-1-4.6-2.2-9.3-3.6-14.2 c-1.9-6.7-3.8-13-5.9-18.9c-10.1-9.7-16.9-18-18.8-22.1c-0.8-1.6-2.1-4.3-1.2-7c0.1-0.4,0.5-1.2,1.3-2.8s1.4-2.9,1.9-3.8 c5.1,1.9,10.5,3.1,15.9,3.4L229,426.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M237.8,403.5c-5.3-0.5-10.3-2.5-14.4-5.8c-3.2-2.7-5.8-6.1-7.5-10c-1.7-3.6-2.7-7.5-2.9-11.5 c0.9-5,1.8-10.2,2.5-15.8c0.3-2.6,0.6-5.2,0.9-7.7l-5.4-2.9c-1.2,4.1-2.2,8.5-3.1,13.2c-1.1,5.2-1.9,10.1-2.6,14.9 c0.7,6.6,2.6,13,5.7,18.9c1.8,3.4,4,6.6,6.6,9.6c-0.7,2.5-1.6,5.1-2.7,7.9c-1.3,3.3-2.7,6.6-4.3,9.8c5.2,5,12.6,7,19.6,5.5 c0.9-2.2,1.8-4.6,2.6-7.1c1.1-3.2,1.9-6.5,2.6-9.8c2.8,0.3,5.7,0.2,8.5-0.2c3-0.5,8-1.3,12.2-5.1c3.5-3.1,4.6-6.6,6.1-10.8 c1.7-4.8,2.5-9.9,2.3-15c-0.7-0.3-1.4-0.5-2.1-0.4c-1,0-1.9,0.4-2.7,1c-1.2,6.9-3.8,13.5-7.6,19.4 C247.7,403.5,242.7,404.3,237.8,403.5L237.8,403.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.5,
    y1: 321.01,
    x2: 629.5,
    y2: 321.01,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#3DC7DC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#3DC7DC",
      stopOpacity: 0.8
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st32",
    cx: 556.5,
    cy: 279,
    rx: 73,
    ry: 7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 544.4,
    y1: 293.64,
    x2: 627.78,
    y2: 293.64,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#E5E8EC",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#6BD5E5",
      stopOpacity: 0.8
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    cx: 586.1,
    cy: 306.4,
    rx: 41.7,
    ry: 5.4
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 562.8,
    y: 215.4,
    transform: "matrix(0.9839 -0.179 0.179 0.9839 -29.2657 109.9899)",
    className: "st0",
    width: 64.3,
    height: 3.5
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 82.6,
    transform: "matrix(0.9825 -0.1862 0.1862 0.9825 -5.6176 108.9838)",
    className: "st0",
    width: 86.9,
    height: 3.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 552,
    cy: 128,
    r: 62.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 552.2,
    cy: 127.8,
    r: 62.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 552.4,
    cy: 127.7,
    r: 62.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 552.5,
    cy: 127.5,
    r: 62.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 552.7,
    cy: 127.3,
    r: 62.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 552.9,
    cy: 127.1,
    r: 62.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 553.1,
    cy: 126.9,
    r: 62.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 553.3,
    cy: 126.7,
    r: 62.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 553.5,
    cy: 126.5,
    r: 62.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 553.7,
    cy: 126.3,
    r: 62.4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 553.8,
    cy: 126.2,
    r: 62.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 554,
    cy: 126,
    r: 62.4
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 554.2,
    cy: 125.8,
    r: 62.4
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 554.4,
    cy: 125.6,
    r: 62.4
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 554.6,
    cy: 125.4,
    r: 62.4
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 554.8,
    cy: 125.2,
    r: 62.4
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 555,
    cy: 125,
    r: 62.4
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 555.2,
    cy: 124.8,
    r: 62.4
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 555.3,
    cy: 124.7,
    r: 62.4
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 555.5,
    cy: 124.5,
    r: 62.4
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 555.7,
    cy: 124.3,
    r: 62.4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M563.9,110.1l-70.5,13.4c0,0.3,0,0.5,0,0.8c0,9.2,2.1,18.3,6,26.6l69.8-13.2L563.9,110.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M559.3,62l-29.7,5.6c-14.9,6.9-26.5,19.3-32.3,34.7L602,82.4C591,70.3,575.7,62.9,559.3,62z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M555.7,186.7c24.4,0,46.6-14.2,56.7-36.4l-100,18.9C524.1,180.4,539.6,186.7,555.7,186.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -45.0568,
    y1: 465.5637,
    x2: 51.0932,
    y2: 561.7137,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M545,203.5c-37.6,0.1-68.1-30.4-68.2-68s30.4-68.1,68-68.2s68.1,30.4,68.2,68c0.1,33.2-23.8,61.6-56.5,67.2 C552.7,203.2,548.9,203.5,545,203.5z M545.2,78.7c-3.2,0-6.4,0.3-9.5,0.8c-30.9,5.2-51.7,34.6-46.5,65.5 c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5C596.5,98.7,572.9,78.7,545.2,78.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.8538,
    y1: 465.7307,
    x2: 51.3162,
    y2: 561.9007,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M545.2,203.3c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3c37.6-0.1,68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C552.9,203,549.1,203.3,545.2,203.3z M545.5,78.5c-31.4-0.1-56.9,25.3-56.9,56.7 c-0.1,31.4,25.3,56.9,56.7,56.9s56.9-25.3,56.9-56.7c0-18.4-8.9-35.8-23.9-46.4C568.7,82.2,557.2,78.5,545.5,78.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.4317,
    y1: 465.6531,
    x2: 51.7394,
    y2: 561.8242,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M545.4,203.1c-37.6-0.1-67.9-30.6-67.8-68.2c0.1-37.6,30.6-67.9,68.2-67.8c33.1,0.1,61.3,24,66.9,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C553.1,202.8,549.3,203.1,545.4,203.1z M545.6,78.3c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C596.9,98.4,573.3,78.4,545.6,78.3 L545.6,78.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.3689,
    y1: 465.9858,
    x2: 51.8011,
    y2: 562.1558,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M545.6,203c-37.6,0.1-68.1-30.4-68.2-68s30.4-68.1,68-68.2s68.1,30.4,68.2,68c0.1,33.2-23.8,61.6-56.5,67.2 C553.3,202.7,549.5,203,545.6,203z M545.8,78.2c-3.2,0-6.4,0.3-9.5,0.8c-30.9,5.2-51.7,34.6-46.5,65.5 c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5C597.1,98.2,573.5,78.2,545.8,78.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.2104,
    y1: 466.1872,
    x2: 51.9596,
    y2: 562.3572,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M545.8,202.8c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3c37.6-0.1,68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C553.5,202.4,549.6,202.8,545.8,202.8z M546,77.9c-31.4-0.1-56.9,25.3-57,56.7 c-0.1,31.4,25.3,56.9,56.7,57c31.4,0.1,56.9-25.3,57-56.7c0-3.2-0.3-6.4-0.8-9.6l0,0C597.3,98,573.7,78,546,77.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.7514,
    y1: 466.1118,
    x2: 52.4147,
    y2: 562.288,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M546,202.6c-37.6-0.1-67.9-30.6-67.8-68.2c0.1-37.6,30.6-67.9,68.2-67.8c33.1,0.1,61.3,24,66.9,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C553.7,202.3,549.9,202.6,546,202.6z M546.2,77.8c-31.4,0-56.8,25.4-56.8,56.8 c0,31.4,25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5l0,0C597.5,97.8,573.9,77.8,546.2,77.8L546.2,77.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.5665,
    y1: 466.2615,
    x2: 52.6096,
    y2: 562.4276,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M546.2,202.4c-37.6-0.1-67.9-30.6-67.8-68.2c0.1-37.6,30.6-67.9,68.2-67.8c33.1,0.1,61.3,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4c0,0,0,0,0,0C553.9,202.1,550,202.4,546.2,202.4z M546.3,77.6c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C597.6,97.6,574,77.6,546.3,77.6 L546.3,77.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.5619,
    y1: 466.6487,
    x2: 52.6081,
    y2: 562.8187,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M546.3,202.2c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3c37.6-0.1,68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C554.1,201.9,550.2,202.2,546.3,202.2z M546.6,77.4c-31.4-0.1-56.9,25.3-56.9,56.7 c-0.1,31.4,25.3,56.9,56.7,56.9c31.4,0.1,56.9-25.3,56.9-56.7c0-3.2-0.3-6.4-0.8-9.6l0,0C597.9,97.4,574.3,77.5,546.6,77.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.137,
    y1: 466.6003,
    x2: 53.0391,
    y2: 562.7664,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M546.5,202c-37.6-0.1-67.9-30.6-67.8-68.2c0.1-37.6,30.6-67.9,68.2-67.8c33.1,0.1,61.3,24,66.9,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C554.2,201.7,550.4,202,546.5,202z M546.7,77.2c-31.4,0-56.8,25.4-56.8,56.8 c0,31.4,25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5l0,0C598,97.2,574.4,77.2,546.7,77.2L546.7,77.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.9396,
    y1: 466.7361,
    x2: 53.2315,
    y2: 562.9072,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M546.7,201.8c-37.6-0.1-67.9-30.6-67.9-68.1s30.6-67.9,68.1-67.9c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.2,37.1-18.8,72.2-56,78.4C554.2,201.5,550.5,201.8,546.7,201.8z M546.9,77c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C598.2,97,574.6,77.1,546.9,77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.9134,
    y1: 467.1102,
    x2: 53.2566,
    y2: 563.2802,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M546.9,201.6c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3c37.6-0.1,68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C554.6,201.3,550.8,201.6,546.9,201.6z M547.2,76.8c-31.4-0.1-56.9,25.3-56.9,56.7 c-0.1,31.4,25.3,56.9,56.7,56.9c31.4,0.1,56.9-25.3,56.9-56.7c0-3.2-0.3-6.4-0.8-9.6l0,0C598.4,96.9,574.8,76.9,547.2,76.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.4761,
    y1: 467.031,
    x2: 53.6949,
    y2: 563.202,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M547.2,201.4c-37.6,0-68-30.5-68-68s30.5-68,68-68c33.2,0,61.5,24,67,56.6l0,0c6.3,37-18.7,72.1-55.7,78.4 C554.8,201.1,551,201.5,547.2,201.4L547.2,201.4z M547.3,76.6c-31.4,0-56.8,25.4-56.8,56.8c0,31.4,25.4,56.8,56.8,56.8 s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5l0,0C598.6,96.7,575,76.7,547.3,76.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.2734,
    y1: 467.1743,
    x2: 53.8977,
    y2: 563.3453,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M547.3,201.3c-37.6-0.1-67.9-30.6-67.9-68.1s30.6-67.9,68.1-67.9c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4C555,200.9,551.1,201.3,547.3,201.3z M547.5,76.5c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C598.8,96.5,575.1,76.5,547.5,76.5 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.2699,
    y1: 467.5668,
    x2: 53.9001,
    y2: 563.7368,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M547.5,201.1c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3c37.6-0.1,68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C555.2,200.7,551.3,201.1,547.5,201.1z M547.7,76.3c-3.2,0-6.4,0.3-9.6,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.5,46.5-65.5l0,0C599,96.3,575.4,76.3,547.7,76.3 L547.7,76.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.9979,
    y1: 467.7047,
    x2: 54.1321,
    y2: 563.8348,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M547.8,200.9c-37.6,0.1-68.2-30.2-68.3-67.8c-0.1-37.6,30.2-68.2,67.8-68.3c37.6-0.1,68.2,30.2,68.3,67.8 c0.1,33.2-23.7,61.6-56.4,67.3C555.4,200.5,551.6,200.9,547.8,200.9z M547.8,76.1c-31.4,0-56.8,25.4-56.8,56.8 c0,31.4,25.4,56.8,56.8,56.8c31.4,0,56.8-25.4,56.8-56.8c0-3.2-0.3-6.4-0.8-9.5C599.1,96.1,575.5,76.2,547.8,76.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.9141,
    y1: 467.9409,
    x2: 54.2559,
    y2: 564.121,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M547.8,200.7c-37.7,0.1-68.4-30.4-68.5-68.2s30.4-68.4,68.2-68.5c37.7-0.1,68.4,30.4,68.5,68.2 c0.1,33.3-23.9,61.8-56.7,67.5C555.5,200.4,551.7,200.7,547.8,200.7z M548.1,75.9c-3.2,0-6.4,0.3-9.6,0.8 C507.7,82,487,111.2,492.3,142s34.5,51.5,65.3,46.2s51.5-34.5,46.2-65.3C599.1,95.8,575.6,75.9,548.1,75.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.4168,
    y1: 467.807,
    x2: 54.7543,
    y2: 563.978,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M548.1,200.5c-37.6,0-68-30.5-68-68c0-37.6,30.5-68,68-68c33.2,0,61.5,23.9,67,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C555.8,200.2,552,200.5,548.1,200.5z M548.2,75.7c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5s34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5c0,0,0,0,0,0l0,0 C599.5,95.7,575.9,75.8,548.2,75.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.4097,
    y1: 468.1765,
    x2: 54.7403,
    y2: 564.3265,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M548.2,200.3c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3c37.6-0.1,68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C555.9,200,552.1,200.3,548.2,200.3z M548.4,75.5c-31.4,0-56.8,25.5-56.8,56.9 c0,3.1,0.3,6.3,0.8,9.3c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5C599.7,95.5,576.1,75.5,548.4,75.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.2146,
    y1: 468.3514,
    x2: 54.9554,
    y2: 564.5314,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M548.4,200.1c-37.7,0.1-68.3-30.4-68.3-68.1s30.4-68.3,68.1-68.3c37.7-0.1,68.3,30.4,68.3,68.1 c0.1,33.2-23.8,61.7-56.6,67.3C556.1,199.8,552.3,200.1,548.4,200.1z M548.7,75.3c-3.2,0-6.4,0.3-9.6,0.8 c-30.8,5.3-51.5,34.5-46.2,65.3c5.3,30.8,34.5,51.5,65.3,46.2s51.5-34.5,46.2-65.3C599.7,95.2,576.2,75.4,548.7,75.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: -40.7902,
    y1: 468.2385,
    x2: 55.3859,
    y2: 564.4045,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M548.7,200c-37.6,0-68-30.5-68-68c0-37.6,30.5-68,68-68c33.2,0,61.5,23.9,67,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C556.3,199.6,552.5,200,548.7,200z M548.9,75.2c-3.2,0-6.4,0.3-9.6,0.8c-30.8,5.3-51.5,34.5-46.2,65.3 s34.5,51.5,65.3,46.2s51.5-34.5,46.2-65.3C599.9,95.1,576.4,75.2,548.9,75.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: -40.6679,
    y1: 468.5848,
    x2: 55.506,
    y2: 564.7587,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M548.9,199.8c-37.6,0.1-68.1-30.2-68.2-67.8s30.2-68.1,67.8-68.2s68.1,30.2,68.2,67.8 c0.1,33.2-23.7,61.6-56.4,67.2C556.5,199.4,552.7,199.8,548.9,199.8z M549,75c-18.4,0-35.7,8.9-46.3,23.9 c-18.2,25.6-12.1,61,13.4,79.2c25.6,18.2,61,12.1,79.2-13.4c18.2-25.6,12.1-61-13.4-79.2C572.2,78.7,560.8,75,549,75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: -40.5364,
    y1: 468.7832,
    x2: 55.6336,
    y2: 564.9532,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M549,199.6c-37.7,0.1-68.3-30.4-68.3-68.1c-0.1-37.7,30.4-68.3,68.1-68.3s68.3,30.4,68.3,68.1 c0.1,33.2-23.8,61.7-56.6,67.3C556.7,199.2,552.9,199.6,549,199.6z M549.3,74.8c-3.2,0-6.4,0.3-9.6,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C600.5,94.8,576.9,74.8,549.3,74.8 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: -40.1281,
    y1: 468.731,
    x2: 56.0429,
    y2: 564.9021,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M549.3,199.4c-37.6,0-68-30.5-68-68c0-37.6,30.5-68,68-68c33.1,0,61.4,23.9,67,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C556.9,199.1,553.1,199.4,549.3,199.4z M549.3,74.6c-31.4,0-56.8,25.4-56.8,56.8 c0,31.4,25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5C600.6,94.6,577,74.7,549.3,74.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: -39.896,
    y1: 468.859,
    x2: 56.2751,
    y2: 565.0301,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M549.3,199.2c-37.6-0.1-67.9-30.6-67.9-68.1s30.6-67.9,68.1-67.9c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4c0,0,0,0,0,0C557,198.9,553.2,199.2,549.3,199.2z M549.5,74.4c-31.4,0-56.8,25.4-56.8,56.8 c0,31.4,25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8c0-3.2-0.3-6.4-0.8-9.5l0,0C600.8,94.4,577.2,74.4,549.5,74.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: -39.9282,
    y1: 469.2751,
    x2: 56.2418,
    y2: 565.4451,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M549.5,199c-37.7,0.1-68.3-30.4-68.3-68.1c-0.1-37.7,30.4-68.3,68.1-68.3s68.3,30.4,68.3,68.1 c0.1,33.2-23.8,61.7-56.6,67.3C557.2,198.7,553.4,199,549.5,199z M549.8,74.2c-3.2,0-6.4,0.3-9.6,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C601,94.2,577.5,74.2,549.8,74.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: -39.4824,
    y1: 469.1855,
    x2: 56.6936,
    y2: 565.3514,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M549.8,198.8c-37.6,0-68-30.5-68-68c0-37.6,30.5-68,68-68c33.2,0,61.5,23.9,67,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C557.4,198.5,553.6,198.8,549.8,198.8z M549.9,74c-31.4,0-56.8,25.4-56.8,56.8 c0,31.4,25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5C601.2,94,577.6,74.1,549.9,74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: -39.2504,
    y1: 469.3176,
    x2: 56.9207,
    y2: 565.4887,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M549.9,198.7c-37.6-0.1-67.9-30.6-67.9-68.1s30.6-67.9,68.1-67.9c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4c0,0,0,0,0,0C557.6,198.3,553.8,198.7,549.9,198.7z M550.1,73.8c-31.4,0-56.8,25.4-56.8,56.8 c0,31.4,25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8c0-3.2-0.3-6.4-0.8-9.5l0,0C601.4,93.9,577.8,73.9,550.1,73.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: -39.2674,
    y1: 469.7243,
    x2: 56.9026,
    y2: 565.8943,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M550.1,198.5c-37.7,0.1-68.3-30.4-68.3-68.1c-0.1-37.7,30.4-68.3,68.1-68.3s68.3,30.4,68.3,68.1 c0.1,33.2-23.8,61.7-56.6,67.3C557.8,198.1,553.9,198.5,550.1,198.5z M550.4,73.7c-3.2,0-6.4,0.3-9.6,0.8 c-30.9,5.2-51.8,34.5-46.5,65.5s34.5,51.8,65.5,46.5c30.9-5.2,51.7-34.5,46.5-65.4l0,0C601.6,93.7,578,73.7,550.4,73.7L550.4,73.7 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: -38.9392,
    y1: 469.8161,
    x2: 57.2347,
    y2: 565.99,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M550.4,198.3c-37.6,0.1-68.1-30.2-68.2-67.8s30.2-68.1,67.8-68.2c37.6-0.1,68.1,30.2,68.2,67.8 c0.1,33.2-23.7,61.6-56.4,67.2C558,197.9,554.2,198.3,550.4,198.3z M550.4,73.5c-31.4,0-56.8,25.4-56.8,56.8 c0,31.4,25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5C601.7,93.5,578.1,73.6,550.4,73.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: -38.8207,
    y1: 470.0176,
    x2: 57.3493,
    y2: 566.1876,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M550.5,198.1c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3s68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C558.2,197.8,554.3,198.1,550.5,198.1z M550.7,73.3c-3.2,0-6.4,0.3-9.6,0.8 c-30.8,5.3-51.5,34.5-46.2,65.3c5.3,30.8,34.5,51.5,65.3,46.2c30.8-5.3,51.5-34.5,46.2-65.3C601.7,93.1,578.2,73.3,550.7,73.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: -38.5337,
    y1: 470.1405,
    x2: 57.711,
    y2: 566.3852,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M550.8,197.9c-37.6,0.1-68.2-30.2-68.3-67.8c-0.1-37.6,30.2-68.2,67.8-68.3s68.2,30.2,68.3,67.8 c0.1,33.2-23.7,61.6-56.4,67.3C558.4,197.6,554.6,197.9,550.8,197.9z M550.9,73.1c-3.2,0-6.4,0.3-9.6,0.8 c-30.9,5.2-51.8,34.5-46.5,65.5c5.2,30.9,34.5,51.8,65.5,46.5c30.9-5.2,51.8-34.5,46.5-65.5c0,0,0,0,0,0l0,0 C602.2,93.1,578.6,73.2,550.9,73.1L550.9,73.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: -38.3396,
    y1: 470.3165,
    x2: 57.7904,
    y2: 566.4365,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M550.9,197.7c-37.6,0.1-68.2-30.2-68.3-67.9s30.2-68.2,67.9-68.3c37.6-0.1,68.2,30.2,68.3,67.9 c0.1,33.2-23.7,61.7-56.5,67.3C558.6,197.4,554.8,197.7,550.9,197.7z M551,72.9c-31.4,0-56.8,25.4-56.8,56.8 c0,31.4,25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5C602.2,93,578.7,73,551,72.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: -38.1838,
    y1: 470.4906,
    x2: 57.9862,
    y2: 566.6606,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M551,197.5c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3s68.2,30.4,68.3,68c0.1,33.2-23.8,61.6-56.5,67.3 C558.7,197.2,554.9,197.5,551,197.5z M551.3,72.7c-3.2,0-6.4,0.3-9.6,0.8c-30.8,5.3-51.5,34.5-46.2,65.3 c5.3,30.8,34.5,51.5,65.3,46.2c30.8-5.3,51.5-34.5,46.2-65.3C602.3,92.6,578.8,72.7,551.3,72.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: -37.7516,
    y1: 470.3979,
    x2: 58.4195,
    y2: 566.5691,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M551.2,197.4c-37.6-0.1-67.9-30.6-67.8-68.2c0.1-37.6,30.6-67.9,68.2-67.8c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C558.9,197,555.1,197.4,551.2,197.4z M551.4,72.5c-18.4,0-35.7,8.9-46.3,23.9 c-18.2,25.6-12.2,61,13.4,79.2c25.6,18.2,61,12.2,79.2-13.4c8.7-12.3,12.2-27.5,9.7-42.4l0,0C602.7,92.6,579.1,72.6,551.4,72.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: -37.7338,
    y1: 470.7706,
    x2: 58.4362,
    y2: 566.9506,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M551.4,197.2c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3c37.6-0.1,68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C559.1,196.8,555.2,197.2,551.4,197.2z M551.6,72.3c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5s51.7-34.6,46.5-65.5C602.9,92.3,579.3,72.4,551.6,72.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: -37.5206,
    y1: 470.9274,
    x2: 58.6494,
    y2: 567.0974,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M551.6,197c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3s68.2,30.4,68.3,68c0.1,33.2-23.8,61.6-56.5,67.3 C559.3,196.7,555.4,197,551.6,197z M551.8,72.2c-3.2,0-6.4,0.3-9.6,0.8c-30.9,5.2-51.7,34.6-46.5,65.5 c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C603.1,92.2,579.5,72.2,551.8,72.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -37.0692,
    y1: 470.8566,
    x2: 59.1019,
    y2: 567.0278,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M551.8,196.8c-37.6-0.1-67.9-30.6-67.8-68.2c0.1-37.6,30.6-67.9,68.2-67.8c33.1,0.1,61.3,24,66.9,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C559.5,196.5,555.6,196.8,551.8,196.8z M551.9,72c-18.4,0-35.7,8.9-46.3,23.9 c-18.2,25.6-12.2,61,13.4,79.2c25.6,18.2,61,12.2,79.2-13.4c8.7-12.3,12.2-27.5,9.7-42.4l0,0C603.2,92,579.6,72.1,551.9,72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: -37.0956,
    y1: 471.2325,
    x2: 59.0744,
    y2: 567.4025,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M552,196.6c-37.7,0.1-68.3-30.4-68.3-68.1s30.4-68.3,68.1-68.3c37.7-0.1,68.3,30.4,68.3,68.1 c0.1,33.2-23.8,61.7-56.6,67.3C559.7,196.3,555.9,196.6,552,196.6z M552.2,71.8c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5C603.5,91.8,579.9,71.8,552.2,71.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.8828,
    y1: 471.3896,
    x2: 59.2872,
    y2: 567.5696,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M552.1,196.4c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3s68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C559.8,196.1,556,196.4,552.1,196.4z M552.4,71.6c-3.2,0-6.4,0.3-9.6,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C603.6,91.6,580.1,71.7,552.4,71.6 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.463,
    y1: 471.322,
    x2: 59.7082,
    y2: 567.4931,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M552.3,196.2c-37.6-0.1-67.9-30.6-67.9-68.1s30.6-67.9,68.1-67.9c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C560,195.9,556.2,196.2,552.3,196.2z M552.5,71.4c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C603.8,91.4,580.2,71.5,552.5,71.4 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.2251,
    y1: 471.5035,
    x2: 59.946,
    y2: 567.6746,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M552.5,196c-37.6-0.1-67.9-30.6-67.8-68.2c0.1-37.6,30.6-67.9,68.2-67.8c33.1,0.1,61.3,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4c0,0,0,0,0,0C560.2,195.7,556.4,196,552.5,196z M552.7,71.2c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C604,91.2,580.4,71.3,552.7,71.2 L552.7,71.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.2418,
    y1: 471.8486,
    x2: 59.9382,
    y2: 568.0286,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M552.7,195.9c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3s68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C560.4,195.5,556.6,195.8,552.7,195.9z M553,71c-3.2,0-6.4,0.3-9.6,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C604.2,91.1,580.7,71.1,553,71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.7991,
    y1: 471.7729,
    x2: 60.3719,
    y2: 567.9439,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M553,195.7c-37.6,0-68-30.5-68-68c0-37.6,30.5-68,68-68c33.2,0,61.5,23.9,67,56.6l0,0 c6.3,37-18.6,72.1-55.7,78.4C560.6,195.3,556.8,195.7,553,195.7z M553.1,70.9c-31.4,0-56.8,25.4-56.8,56.8s25.4,56.8,56.8,56.8 s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5l0,0C604.4,90.9,580.8,70.9,553.1,70.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.5836,
    y1: 471.9203,
    x2: 60.5825,
    y2: 568.0964,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M553.1,195.5c-37.6-0.1-67.9-30.6-67.8-68.2c0.1-37.6,30.6-67.9,68.2-67.8c33.1,0.1,61.3,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4c0,0,0,0,0,0C560.8,195.2,556.9,195.5,553.1,195.5z M553.2,70.7c-31.4,0-56.8,25.4-56.8,56.8 s25.4,56.8,56.8,56.8c31.4,0,56.8-25.4,56.8-56.8c0-3.2-0.3-6.4-0.8-9.5l0,0C604.6,90.7,580.9,70.7,553.2,70.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.6668,
    y1: 472.3837,
    x2: 60.5032,
    y2: 568.5536,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M553.3,195.3c-37.7,0.1-68.4-30.4-68.5-68.2s30.4-68.4,68.2-68.5c37.7-0.1,68.4,30.4,68.5,68.2 c0.1,33.3-23.9,61.8-56.7,67.5C561,195,557.1,195.3,553.3,195.3z M553.5,70.5c-3.2,0-6.4,0.3-9.6,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C604.8,90.5,581.2,70.6,553.5,70.5 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.3038,
    y1: 472.4407,
    x2: 60.8262,
    y2: 568.5607,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M553.6,195.1c-37.6,0.1-68.2-30.2-68.3-67.8s30.2-68.2,67.8-68.3s68.2,30.2,68.3,67.8 c0.1,33.2-23.7,61.6-56.4,67.3C561.2,194.8,557.4,195.1,553.6,195.1z M553.6,70.3c-31.4,0-56.8,25.4-56.8,56.8 s25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5C604.9,90.3,581.3,70.4,553.6,70.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.1748,
    y1: 472.6317,
    x2: 60.9952,
    y2: 568.8017,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M553.6,194.9c-37.7,0.1-68.3-30.4-68.3-68.1c-0.1-37.7,30.4-68.3,68.1-68.3s68.3,30.4,68.3,68.1 c0.1,33.2-23.8,61.7-56.6,67.3C561.3,194.6,557.5,194.9,553.6,194.9z M553.9,70.1C522.5,70,497,95.4,497,126.8 c-0.1,31.4,25.3,56.9,56.7,56.9c31.4,0.1,56.9-25.3,56.9-56.7c0-18.4-8.9-35.8-23.9-46.4C577.1,73.8,565.6,70.1,553.9,70.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.9482,
    y1: 472.815,
    x2: 61.2018,
    y2: 568.965,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M553.9,194.7c-37.7,0.1-68.3-30.3-68.5-68c-0.1-37.7,30.3-68.3,68-68.5c37.7-0.1,68.3,30.3,68.5,68 c0.1,33.3-23.8,61.8-56.6,67.5C561.6,194.4,557.7,194.7,553.9,194.7z M554.1,69.9c-3.2,0-6.4,0.3-9.6,0.8 c-30.9,5.3-51.7,34.6-46.5,65.5s34.6,51.7,65.5,46.5c30.9-5.3,51.7-34.6,46.5-65.5l0,0C605.4,90,581.8,70,554.1,69.9L554.1,69.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.7389,
    y1: 472.9257,
    x2: 61.4112,
    y2: 569.0757,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M554,194.6c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3s68.2,30.4,68.3,68c0.1,33.2-23.8,61.6-56.5,67.3 C561.7,194.2,557.9,194.5,554,194.6z M554.2,69.7c-31.4,0-56.8,25.4-56.8,56.8s25.4,56.8,56.8,56.8c31.4,0,56.8-25.4,56.8-56.8 c0-3.2-0.3-6.3-0.8-9.5C605.5,89.8,581.9,69.8,554.2,69.7L554.2,69.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.5263,
    y1: 473.0932,
    x2: 61.6437,
    y2: 569.2632,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M554.2,194.4c-37.7,0.1-68.3-30.4-68.3-68.1c-0.1-37.7,30.4-68.3,68.1-68.3s68.3,30.4,68.3,68.1 c0.1,33.2-23.8,61.7-56.6,67.3C561.9,194,558,194.3,554.2,194.4z M554.5,69.5c-31.4,0-56.8,25.4-56.9,56.7s25.4,56.8,56.7,56.9 c31.4,0,56.8-25.4,56.9-56.7c0-18.4-8.9-35.8-24-46.4C577.7,73.2,566.2,69.5,554.5,69.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.0901,
    y1: 472.9998,
    x2: 62.0811,
    y2: 569.1709,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M554.4,194.2c-37.6-0.1-67.9-30.6-67.8-68.2c0.1-37.6,30.6-67.9,68.2-67.8c33.1,0.1,61.3,24,66.9,56.6l0,0 c6.2,37-18.7,72.1-55.7,78.4C562.1,193.8,558.2,194.2,554.4,194.2z M554.6,69.4c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C605.9,89.4,582.2,69.4,554.6,69.4 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.0387,
    y1: 473.3456,
    x2: 62.1313,
    y2: 569.5156,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M554.6,194c-37.6,0.1-68.1-30.4-68.2-68s30.4-68.1,68-68.2c37.6-0.1,68.1,30.4,68.2,68 c0.1,33.2-23.8,61.6-56.5,67.2C562.3,193.7,558.4,194,554.6,194z M554.7,69.2c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5C606.1,89.2,582.4,69.2,554.7,69.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.8704,
    y1: 473.5372,
    x2: 62.3096,
    y2: 569.7073,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M554.8,193.8c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3s68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C562.5,193.5,558.6,193.8,554.8,193.8z M555,69c-31.4-0.1-56.9,25.3-56.9,56.7s25.3,56.9,56.7,56.9 s56.9-25.3,56.9-56.7c0-3.2-0.3-6.4-0.8-9.6l0,0C606.3,89,582.7,69.1,555,69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.4431,
    y1: 473.4675,
    x2: 62.7279,
    y2: 569.6385,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M555,193.6c-37.6,0-68-30.5-68-68c0-37.6,30.5-68,68-68c33.1,0,61.5,23.9,67,56.6l0,0 c6.2,37.1-18.8,72.2-55.9,78.4C562.6,193.3,558.8,193.6,555,193.6L555,193.6z M555.2,68.8c-3.2,0-6.4,0.3-9.6,0.8 c-30.8,5.3-51.5,34.5-46.2,65.3c5.3,30.8,34.5,51.5,65.3,46.2s51.5-34.5,46.2-65.3C606.3,88.7,582.8,68.8,555.2,68.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.2207,
    y1: 473.6012,
    x2: 62.9504,
    y2: 569.7723,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M555.1,193.4c-37.6-0.1-67.9-30.6-67.9-68.1s30.6-67.9,68.1-67.9c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4c0,0,0,0,0,0C562.8,193.1,559,193.4,555.1,193.4z M555.3,68.6c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C606.6,88.6,583,68.7,555.3,68.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.2194,
    y1: 473.9962,
    x2: 62.9506,
    y2: 570.1663,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M555.3,193.2c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3s68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C563,192.9,559.2,193.2,555.3,193.2z M555.6,68.4c-31.4-0.1-56.9,25.3-57,56.7 c-0.1,31.4,25.3,56.9,56.7,57c31.4,0.1,56.9-25.3,57-56.7c0-3.2-0.3-6.4-0.8-9.6l0,0C606.8,88.5,583.2,68.5,555.6,68.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.7736,
    y1: 473.9585,
    x2: 63.3975,
    y2: 570.1295,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M555.6,193c-37.6,0-68-30.5-68-68s30.5-68,68-68c33.2,0,61.5,24,67,56.6l0,0c6.3,37-18.7,72.1-55.7,78.4 C563.2,192.7,559.4,193,555.6,193z M555.7,68.2c-31.4,0-56.8,25.4-56.8,56.8c0,31.4,25.4,56.8,56.8,56.8s56.8-25.4,56.8-56.8 c0-3.2-0.3-6.3-0.8-9.5C606.9,88.3,583.3,68.4,555.7,68.2L555.7,68.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.575,
    y1: 474.0598,
    x2: 63.5961,
    y2: 570.2309,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M555.7,192.9c-37.6-0.1-67.9-30.6-67.9-68.1s30.6-67.9,68.1-67.9c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4c0,0,0,0,0,0C563.4,192.5,559.5,192.9,555.7,192.9z M555.9,68c-3.2,0-6.4,0.3-9.5,0.8 c-30.9,5.2-51.7,34.6-46.5,65.5c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C607.2,88.1,583.5,68.1,555.9,68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.5709,
    y1: 474.4578,
    x2: 63.5991,
    y2: 570.6277,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M555.9,192.7c-37.6,0.1-68.2-30.4-68.3-68s30.4-68.2,68-68.3s68.2,30.4,68.3,68 c0.1,33.2-23.8,61.6-56.5,67.3C563.6,192.3,559.7,192.7,555.9,192.7z M556.1,67.8c-31.4-0.1-56.9,25.3-56.9,56.7 s25.3,56.9,56.7,56.9c31.4,0.1,56.9-25.3,56.9-56.7c0-3.2-0.3-6.4-0.8-9.6l0,0C607.4,87.9,583.8,67.9,556.1,67.8L556.1,67.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.1345,
    y1: 474.3777,
    x2: 64.0365,
    y2: 570.5487,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M556.2,192.5c-37.6,0-68-30.5-68-68s30.5-68,68-68c33.2,0,61.5,24,67,56.6l0,0c6.3,37-18.7,72.1-55.7,78.4 C563.8,192.2,560,192.5,556.2,192.5L556.2,192.5z M556.2,67.7c-31.4,0-56.8,25.4-56.8,56.8c0,31.4,25.4,56.8,56.8,56.8 s56.8-25.4,56.8-56.8c0-3.2-0.3-6.3-0.8-9.5C607.5,87.8,583.9,67.8,556.2,67.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.9319,
    y1: 474.5209,
    x2: 64.2392,
    y2: 570.692,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057D8"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M556.2,192.3c-37.6-0.1-67.9-30.6-67.9-68.1s30.6-67.9,68.1-67.9c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4C564,192,560.1,192.3,556.2,192.3z M556.4,67.5c-3.2,0-6.4,0.3-9.5,0.8c-30.9,5.2-51.7,34.6-46.5,65.5 c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C607.7,87.5,584.1,67.5,556.4,67.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.9093,
    y1: 394.8962,
    x2: 63.0741,
    y2: 437.061,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0057D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0065FF"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M619.2,273.4c-3.5,0-6.8-2-8.4-5.2l-38.9-77.9c-2.3-4.6-0.5-10.2,4.2-12.6c4.6-2.3,10.2-0.5,12.6,4.2 l38.9,77.9c2.3,4.6,0.4,10.2-4.2,12.5C622,273,620.6,273.4,619.2,273.4L619.2,273.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.8473,
    y1: 522.618,
    x2: 84.1637,
    y2: 522.618,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66A3FF"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M556.2,192.3c-37.6-0.1-67.9-30.6-67.9-68.1s30.6-67.9,68.1-67.9c33.1,0.1,61.4,24,66.9,56.6l0,0 c6.3,37-18.7,72.1-55.7,78.4C564,192,560.1,192.3,556.2,192.3z M556.4,67.5c-3.2,0-6.4,0.3-9.5,0.8c-30.9,5.2-51.7,34.6-46.5,65.5 c5.2,30.9,34.6,51.7,65.5,46.5c30.9-5.2,51.7-34.6,46.5-65.5l0,0C607.7,87.5,584.1,67.5,556.4,67.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.7406,
    y1: 378.584,
    x2: 67.6494,
    y2: 417.5028,
    gradientTransform: "matrix(0.986 -0.1669 -0.1669 -0.986 627.7054 642.2746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66A3FF"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M621.6,281.5c-5.3,0-10.2-3-12.5-7.7l-25.7-51.4c-3.5-6.9-0.7-15.3,6.3-18.8c6.9-3.5,15.3-0.7,18.8,6.3 l25.7,51.4c3.5,6.9,0.7,15.3-6.2,18.8C626,281,623.8,281.5,621.6,281.5z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M561,182.1l4.2-2.6l-1.8-1.7l-3.2,3.2c-0.2,0.3-0.2,0.7,0.1,0.9C560.5,182.2,560.8,182.2,561,182.1 L561,182.1z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M567.9,180.5l-2.5,1.2l-5.2-0.6l-2.9-0.6l0.4-1.8l2.8-1.4c0.6-0.3,1.3-0.5,2-0.7l0,0c1-0.2,2-0.1,3,0.1 l2,0.5L567.9,180.5z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M524.6,202.9c-0.4-0.8-1-1.5-1.7-2c-1.3-1-2.2-0.9-5-2.2c-2.1-1-2.3-1.3-2.3-1.6c0-0.4,0.7-0.6,1.3-0.8 c0.3-0.2,0.5-0.3,0.8-0.4c1.2-0.3,2.2,0.1,3.6,0.6c1,0.3,2.1,0.6,3.1,0.7c0.5,0.1,1-0.1,1.4-0.4c1-0.9,0-3.3,0.6-3.5 c0.1,0,0.3,0,0.4,0.1c0.7,0.4,0.9,1.3,1.1,3c0.2,1.1,0.3,2.3,0.3,3.4c-0.1,1.2-0.4,2.3-0.9,3.4L524.6,202.9z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M571.6,237.1c1.1,2,2.1,4.1,3.1,6.4c3.6,8.3,6,17.1,7.2,26.1c1,2.7,2,5.6,3,8.5c2.5,7.8,4.3,15.7,5.5,23.8 l-4.7,1.4c-1.6-4.4-4.2-11.3-7.5-19.8c-4.2-10.7-6.2-16.1-6.3-16.3c-5.8-13.6-9-17.3-7.5-22.4C564.8,243.1,566.3,240,571.6,237.1z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 530.115,
    y1: 307.535,
    x2: 578.465,
    y2: 355.885,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#0049B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0065FF"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M556.6,240.6c-2.9,9.3-5.9,18.5-8.8,27.8l-7.9,33.9l4.6,1.2c2.8-6.8,5.6-14.1,8.2-21.7 c1.3-3.9,2.6-7.7,3.7-11.5c1.6-3.3,3.8-6.3,6.3-9c4.5-4.7,8.2-6,10.8-11.2c2-3.9,1.3-6.1,1.1-6.6s-0.5-1.1-1.2-2.6 s-1.3-2.7-1.8-3.6c-2,0.7-4,1.4-6,1.9C562.7,239.9,559.7,240.4,556.6,240.6z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M540.8,295.7c-0.1,1.9-0.5,3.8-1.2,5.6c-1,2.8-2.9,5.2-5.3,6.9c-1.5,1-3.3,1.7-5.1,1.9 c0.1,0.4,0.1,0.3,0.1,0.7c2.3,0,7.2,0.1,9.5,0.1c0.2-0.7,0.9-1.1,1.6-0.9c0.3,0.2,0.5,0.5,0.6,0.9l2.4-0.2c0.3-1,0.5-2,0.8-3 c1.2-4.1,2.4-8.1,3.7-11.9L540.8,295.7z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M582.9,296.1c0.8,2,1.5,4.1,1.8,6.3c0.1,1.9,0.2,3.4-0.7,4.7c-0.8,1-1.8,1.7-2.9,2.2 c-0.9,0.5-1.8,0.9-2.8,1.2c0.1,0.4,0.1,0.3,0.2,0.7l6.3-0.2h1.6c0.1-0.3,0.3-0.6,0.5-0.7c0.3-0.1,0.6-0.1,0.9,0.1 c0.2,0.1,0.4,0.3,0.5,0.5c0.6,0,1.1,0,1.7,0c0.6,0,1.2-0.1,1.8-0.2l-0.5-3.1c-0.1-0.6-0.2-1.6-0.5-3.1c-0.5-3.5-1.2-7.9-1.4-8.9 L582.9,296.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.72,
    y1: 389.745,
    x2: 578,
    y2: 389.745,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#0057D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0065FF"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M547.8,218.1c0,0,9.4-0.9,14-4.8l0.6-0.5l0.3-0.3c3.4-3,6.9-7.8,8.9-15.5c-1.1-5.6-3.6-10.9-7.2-15.4 l3.1-4.3c6,5.3,9.7,12.7,10.4,20.7c-1.6,8.1-5.2,15.6-10.5,21.9c-0.1,2.5,0.1,5,0.5,7.5c0.7,3.8,2.1,7.5,4.1,10.8l-16.6,5.2 c1.4-3.1,1.2-5,0.7-6.2c-1.2-2.8-4.1-3.3-5.3-6.5c-0.5-1.5-0.6-3.2-0.1-4.7c-7.6,0.6-15.3-0.5-22.3-3.4 c-2.8-6.9-4.8-14.2-5.8-21.6l5.7,0.6c0.3,2.3,0.7,4.5,1.3,6.7c0.7,2.9,1.7,5.8,2.9,8.6C537.5,218.1,542.7,218.6,547.8,218.1z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M550.6,204.4c0.2,0.1,0.5,0.1,0.7,0.2c0.7,0.1,1.3,0.3,1.9,0.7c1,0.7,0.3,2.1,1.2,4c0.2,0.5,0.4,1,0.5,1.6 c0,0.3,0.1,0.5,0.1,0.8c0,0.6,0.4,2,1.9,4.8l-0.9-0.3c-1-0.3-1.9-0.6-2.8-1.1c-2-1-2.3-1.7-2.3-1.9c-0.1-0.2-0.1-0.4-0.1-0.6 c0-1.1,0-3.1-0.1-3.2c-0.7-0.4-0.8-0.6-0.8-0.8s0.3-0.3,0.5-0.8c0.1-0.2,0.2-0.5,0.2-0.8C550.7,206.2,550.7,205.3,550.6,204.4z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M553.2,205.2c-0.3,3.9,0.2,7.8,1.5,11.4l0.1,0.4c1.5,4.2,6.2,6.4,10.4,4.8c0.4-0.2,0.9-0.4,1.3-0.6l0.5-0.2 h0.1c2.4-1.7,3-5,1.3-7.4c-0.1-0.2-0.3-0.4-0.4-0.5c-1.2-1.3-2.2-2.8-3-4.4c-2-3.9-1.7-6.7-4.3-8.2c-1.7-0.8-3.6-1.1-5.5-0.9 c-1,0-2,0.3-2.8,0.8c-0.6,0.5-1.2,1.1-1.5,1.8c-0.4,0.7-0.6,1.5-0.7,2.3c0.4,0,0.9,0.1,1.3,0.2C552,204.8,552.6,205,553.2,205.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M378.5,409.9c0,0,4.2-1.2,4.1-2.4c-0.1-0.7-3.2,0.9-3.6,0.1c-0.3-0.9-0.4-1.8-0.2-2.8l-1.9,4.2L378.5,409.9z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: -5150.6597,
    y1: 86.77,
    x2: -5083.2197,
    y2: 86.77,
    gradientTransform: "matrix(-1 0 0 -1 -4787.6299 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#3DC7DC",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#3DC7DC",
      stopOpacity: 0.3
    }
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st106",
    cx: 329.3,
    cy: 513.2,
    rx: 33.7,
    ry: 5.4
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M344.5,397.1c0.5,1.5,1.1,3,1.8,4.4c3,6.1,7.6,11.3,13.4,15.1c-0.9,2-2.1,3.7-3.6,5.2 c-7.1,6.6-18.1,3.8-19.3,3.5c-7.1-5.1-9.3-14.1-5.8-20.5C333.5,400,338.8,397.2,344.5,397.1z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M346.3,403.2c-0.6,0.1-1.1,0-1.6-0.4c-0.4-0.4-0.7-0.9-0.8-1.5c-0.3-1.2-0.5-2.4-0.6-3.6l-7.7,1 c0.1,0.5,0.2,1.2,0.3,1.9c0.2,1.8,0.3,2.2,0.1,2.7c-0.2,0.5-0.5,1-0.9,1.4c1.6,0.4,3.3,0.5,5,0.4 C342.3,404.9,344.4,404.3,346.3,403.2z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M348.9,402.8c-2.4,0.2-5,0.5-7.5,0.9c-3.1,0.5-6.1,1-8.9,1.5l0.9,4.4l12.3,1.8l4.4-7.1L348.9,402.8z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M335.9,400.9c1.2-0.1,5.9-0.3,8.7-1.5c0.5-0.2,1.8-0.8,1.9-1.7c0-0.4-0.2-0.6-0.2-1.4 c0-0.6,0.1-0.7,0.1-1.1c0-0.5-0.2-1-0.4-1.5c0.2-0.1,0.5-0.3,0.7-0.5c0.3-0.2,0.4-0.4,0.5-0.5c0.1-0.5-0.9-0.8-1.4-1.8 c-0.2-0.4-0.3-0.8-0.4-1.2c-0.4-0.8-0.8-1.5-1.3-2.2c-0.5-0.7-1-1.3-1.6-1.9l0,0c-1.6-1.6-3.7-2.3-6-2.1l0,0 c-2.4,0.2-4.6,1.5-5.8,3.6l-0.2,0.4c-0.3,0.5-0.5,1-0.5,1.5l0,0c-0.4,2.9,0.8,5.7,3.2,7.4l1.4,1L335.9,400.9z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M329.6,393.8c1.3,2.7,2.9,3.3,3.5,5.9c0.4,1.8,0.2,3.8-0.6,5.5c2.3,0.4,4.7,0,6.6-1.3 c3.4-2.5,4.6-7.9,2.3-12.9c1.7-1.7,2.3-3.8,1.6-5.4c-0.6-1.1-1.6-1.8-2.7-2.1c-3.2-1.1-8.6-0.5-10.7,3.6 C328.6,389.2,328.6,391.7,329.6,393.8z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M324.6,505.6c0.3,1.1,0.5,2.3,0.5,3.5c0,1.1-0.1,2.1-0.3,3.1l-1.7,0.8l-0.4-0.7l-0.6,1.2 c-1,0.6-2.1,1.1-3.2,1.4c-0.9,0.3-1.8,0.5-2.7,0.5c-1.5,0-3.6-0.3-3.8-1c-0.1-0.5,0.7-0.7,2.3-2c1.1-0.8,2-1.8,2.8-2.9 c0.8-1.1,1.4-2.3,1.8-3.6l0.3-0.9L324.6,505.6z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M345.7,504.9c0,1.3,0.5,2.6,1.3,3.6c2.5,3.1,8,2.6,8.1,4c0,0.2-0.1,0.3-0.2,0.5c-6.2,0.6-8.5,0.3-9.3-0.2 c-0.4-0.3-1-0.5-1.5-0.4c-0.4,0.1-0.7,0.3-1,0.5h-4.2c-0.1-1.6,0-3.1,0.1-4.7c0.1-0.8,0.2-1.7,0.4-2.5L345.7,504.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: -5122.5098,
    y1: 156.24,
    x2: -5122.5098,
    y2: 161.07,
    gradientTransform: "matrix(-1 0 0 -1 -4787.6299 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF991F"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "330.2,438.9 330.2,443.8 339.5,439.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: -5335.8545,
    y1: 190.9536,
    x2: -5335.8545,
    y2: 261.2636,
    gradientTransform: "matrix(-1 -6.000000e-02 6.000000e-02 -1 -5012.9902 386.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#0057D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#0059DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#005EEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#0065FF"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M349.7,437.4c0.1,2,0.3,5,0.4,8.6c0.3,12.4-1,20.7-1.8,33c-0.5,7.1-1.2,16.2-2,26.8l-7.2,0 c0.1-1.8,0.1-4.6,0-8c-0.3-7.2-1.2-10.1-1.1-15.6c0.1-3.1,0.5-6.2,1.2-9.2c-1.3-6.5-2.6-12.9-3.9-19.4c-3.4-1-6.2-3.3-7.7-6.5 c-1.8-4.1-1.2-8.8,1.6-12.3L349.7,437.4z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "330.5,437.6 328.5,437.1 326.8,436.9 328.5,439.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: -1137.3804,
    y1: 700.6644,
    x2: -1137.3804,
    y2: 773.7157,
    gradientTransform: "matrix(0.9546 0.298 0.298 -0.9546 1193.0964 1512.5703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0057D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0065FF"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M345.2,437.3c-1.4,3.8-2.8,7.7-4.2,11.6c-2.9,8-5.6,15.9-8.1,23.6c-2.1,11.5-4.2,22.9-6.2,34.4l-7.2-1.1 c1.1-11.9,2.2-23.8,3.3-35.6c0.3-3.7,2-27,2.7-30.2c0.1-0.6,0.3-1.1,0.3-1.1c0.5-1.6,1.2-3.2,2.1-4.6l1.3,0.7L345.2,437.3z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M330.6,438.1c-0.3-1-0.6-1.8-0.8-2.7c-1.3,1.5-2.5,3.1-3.6,4.8c0.3,0.2,0.5,0.4,0.8,0.6 c0.2,0.1,0.4,0.2,0.7,0.2c0.4,0,0.9-0.1,1.3-0.3c0.5-0.2,0.8-1.1,1-1.4s0.4-0.3,0.5-0.5C330.7,438.5,330.7,438.3,330.6,438.1z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M326.9,433.6c0.4,0.3,1.2,0.6,1.7,0.9c0.5,0.3,0.9,0.6,1.3,1c-1.2,1.5-2.5,3.1-3.6,4.8 c-0.2-0.3-0.3-0.5-0.5-0.8s-0.2-0.6-0.6-0.9c-0.7-0.6-1.2-1.3-1.5-2.2c-0.1-0.6-0.2-1.2-0.1-1.9l2.4-1.9 C326.3,432.9,326.6,433.3,326.9,433.6z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M361.5,416.7c-2.4-2.6-7.7-13.5-14-14.8c-1.2,2-2,3.8-4.4,5c-1.2,0.6-2.4,0.3-4.2,0c-2.1-0.3-4.1-1-5.9-1.9 c-2.1,1.3-4,2.4-6.1,3.7c-5.3,3.5-10.1,5.9-11.8,12.9c-0.5,2.2,1.1,6,2.6,8.4c1.3,2.1,3,5.2,4.9,7.1c1.4-0.3,2.7-1,3.8-1.9 c0.6-0.6,1.2-1.2,1.6-1.9c-1.2-1.6-2.3-3.3-3.3-5.1c-1.3-1.7-2.4-3.5-3.3-5.5c1.1-1.5,2.4-2.8,3.9-3.8c1.6-1.1,3.3-2.1,5-2.9 c0.1,1.6,0.2,3.2,0.5,4.8c0.4,2.2,1,4.4,1.8,6.6c-0.8,1.4-1.6,2.7-2.4,4.1c-0.6,1-1.2,1.9-1.8,2.9c4.3,2.6,9.3,4,14.3,4 c2.9-0.1,5.9-0.6,8.6-1.6c-0.4-4.4-1.2-8.7-2.4-13c0.4-1,0.8-1.7,1.1-2.8c0.5-1.1,0.8-2.3,0.8-3.5c0-0.8-0.5-2-0.6-3 c-0.1-0.7-0.4-2.1-0.4-2.9c1.4,1.8,7.6,11.9,10.1,12.1c3.9,0.3,18.4-11.4,19.8-13.6c-1.1-1-2.5-1.8-3.6-2.9 C374.1,409.4,364.6,415.3,361.5,416.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.b423a6cf7075ce3f4b85d573f75a00c3.svg";
export { ForwardRef as ReactComponent };